import { ListViewItem } from '@ingka/list-view';
import creditCard from '@ingka/ssr-icon/paths/credit-card';
import { translate } from '@repo/phrase';

import { Feature } from '@/components/feature';

import { useAssetParams } from '@/hooks/asset.hooks';
import { getAppConfig } from '@/utils/window.utils';

const RimsPaymentMethodListViewItem = () => {
    const { assetId } = useAssetParams();
    const config = getAppConfig();
    const rimsUrl = new URL(`${config.feature.paymentsRims?.url}${assetId}`);

    return (
        <ListViewItem
            title={translate('orderview_payments_options')}
            description={translate('orderview_payments_rims_title')}
            emphasised
            leadingIcon={creditCard}
            control="navigational"
            controlIcon="chevronRight"
            data-testid="rims-payment-method-btn"
            href={rimsUrl.href}
            onClick={() => {
                globalThis.location.href = rimsUrl.href;
            }}
        />
    );
};

export const RimsPaymentMethod = () => {
    const config = getAppConfig();

    if (!config.feature.paymentsRims?.url) {
        return null;
    }

    return (
        <Feature configPath={['paymentsRims.enable']}>
            <RimsPaymentMethodListViewItem />
        </Feature>
    );
};
